export const namespaced = true;

export const state = {
    additionalWorks: {
        install: [],
        service: [],
        polish: {
            stely: [],
            tumby: [],
            cvetniki_nadgrobiya: []
        }
    },
    selectedAdditionalWorks: {
        install: null,
        service: [],
        polish: {
            stely: null,
            tumby: null,
            cvetniki_nadgrobiya: null
        }
    }
};

export const mutations = {
    FETCH_ADDITIONAL_WORKS(state, { type, additionalWorks }) {
        const arrType = type.split(".");
        if (arrType.length > 1) {
            state.additionalWorks[arrType[0]][arrType[1]] = additionalWorks;
        } else {
            state.additionalWorks[type] = additionalWorks;
        }
    },
    SELECT_ADDITIONAL_WORK(state, { type, additionalWork }) {
        state.selectedAdditionalWorks[type] = additionalWork;

        const arrType = type.split(".");
        if (arrType.length > 1) {
            state.selectedAdditionalWorks[arrType[0]][
                arrType[1]
            ] = additionalWork;
        } else {
            state.selectedAdditionalWorks[type] = additionalWork;
        }
    },
    UNSELECT_ADDITIONAL_WORK(state, type) {
        const arrType = type.split(".");
        if (arrType.length > 1) {
            state.selectedAdditionalWorks[arrType[0]][arrType[1]] = null;
        } else {
            state.selectedAdditionalWorks[type] = null;
        }
    }
};

export const actions = {
    async fetch({ commit, state, dispatch }, type) {
        try {
            const res = (await axios.get(`/api/additional_works/${type}`)).data;
            commit("FETCH_ADDITIONAL_WORKS", {
                type,
                additionalWorks: res.data
            });
            return res.data;
        } catch (error) {
            const notification = {
                element: "error",
                message:
                    error.response &&
                    error.response.data &&
                    error.response.data.message
            };
            dispatch("notification/add", notification, { root: true });
        }
    },

    selectAdditionalWork({ commit, dispatch }, { type, additionalWork }) {
        commit("SELECT_ADDITIONAL_WORK", { type, additionalWork });
        dispatch(
            "clientOrder/addAdditionalWork",
            { type, additionalWork },
            { root: true }
        );
    },

    unSelectAdditionalWork({ commit, dispatch }, type) {
        commit("UNSELECT_ADDITIONAL_WORK", type);
        dispatch("clientOrder/removeAdditionalWork", type, { root: true });
    }
};
